'use strict'

const AccessPolicy = require('./access-policy')
const FeaturePolicy = require('./feature-policy')
const Q = require('q')

const _configureGlobalPolicy = (documents) => {

    return FeaturePolicy.create()
        .then(featurePolicy => {

            if (!Array.isArray(documents) || !documents.length) {
                return featurePolicy
            }

            return documents.reduce((policy, document) => {
                return policy.mergeDocument(document)
            }, featurePolicy)

        })

}

const _mergePoliciesByAccount = (results) => {

    const policiesByAccountId = {}
    const promises = results.map(r => {
        return FeaturePolicy.create()
            .then(featurePolicy => {
                if (!(r.accountId in policiesByAccountId)) {
                    policiesByAccountId[r.accountId] = featurePolicy
                }
                policiesByAccountId[r.accountId].mergeDocument(r.document)
            })
    })

    return Q.all(promises).then(() => policiesByAccountId)

}

const _prepareInitialState = (results) => {

    const state = {
        globalPolicyResults: results[0],
        accountPolicyResults: results[1],
        accessPolicy: results[2]
    }

    const promises = [
        _configureGlobalPolicy(state.globalPolicyResults)
            .then(policy => {
                state.globalPolicy = policy
                return state
            }),
        _mergePoliciesByAccount(state.accountPolicyResults)
            .then(policiesByAccount => {
                state.accountPoliciesForRoles = policiesByAccount
                return state
            })
    ]
    return Q.all(promises).then(() => state)

}

/**
 * Resolve all feature and access policies for a set of principals into
 * a single access policy
 * @param principals
 * @param params
 */
const resolvePolicy = (principals, params) => {
    const promises = [
        params.featureHelpers.getGlobalPoliciesForPrincipals(principals),
        params.featureHelpers.getPrincipalRoleAssignments(principals),
        AccessPolicy.forPrincipals(principals, params.accessHelpers)
    ]
    return Q.all(promises)
        .then(results => _prepareInitialState(results))
        .then(state => {
            const accountIds = Object.keys(state.accountPoliciesForRoles)
            return params.featureHelpers.getAccountBundlePolicies(accountIds)
                .then(results => _mergePoliciesByAccount(results))
                .then(bundlePolicies => {
                    state.bundlePolicies = bundlePolicies
                    return state
                })
        })
        .then(state => {
            const promises = Object.keys(state.bundlePolicies)
                .reduce((a, accountId) => {
                    const bundlePolicy = state.bundlePolicies[accountId]
                    const rolesPolicy = state.accountPoliciesForRoles[accountId]
                    if (rolesPolicy) {
                        a.push(bundlePolicy.appendPolicy(rolesPolicy))
                    }
                    return a
                }, [])
            return Q.all(promises)
                .then(results => {
                    return results.reduce((promise, nextPolicy) => {
                        return promise.then(policy => {
                            return policy.mergePolicy(nextPolicy)
                        })
                    }, Q(state.globalPolicy))
                })
                .then(featurePolicy => {
                    return featurePolicy.toAccessStatements()
                })
                .then(statements => {
                    return AccessPolicy.fromStatements(
                        statements,
                        params.accessHelpers
                    )
                })
                .then(accessPolicy => {
                    return state.accessPolicy.mergePolicy(accessPolicy)
                })
        })
}

module.exports = {
    resolvePolicy,
    _testExports: {
        _configureGlobalPolicy,
        _mergePoliciesByAccount,
        _prepareInitialState
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/resolver.js
// module id = 298
// module chunks = 51